import { useContext, useEffect, useState } from 'react'
import { AppContext } from '../contextApi/ContextApi'
import { media } from '../dataSets/media';

export default function WebsiteNotActive({isDashboard}) {
    const {currentWebsite, fetchImage, primary_color, secondary_color, accent_color} = useContext(AppContext);
    const [domain] = useState(currentWebsite?.settings?.domain);
    const [imgURL, setImgURL] = useState(media.webingoLogo);
    useEffect(()=>{
        fetchImage(currentWebsite, currentWebsite?.settings?.logo, setImgURL);
    },[])
    return (
        <div style={{backgroundColor: primary_color, width: isDashboard ? "100%" : "100vw", height:"100vh", display:"flex", alignItems:"center", justifyContent:"center"}}>
            <div style={{backgroundColor:secondary_color, width:"85%", height:"85%", borderRadius:"20px", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"space-evenly"}} dir='rtl'>
                <h1 style={{color:accent_color, textShadow:`2px 2px 4px ${primary_color}`, margin:"0"}}>{`האתר ${currentWebsite?.settings?.website_name} סגור זמנית`}</h1>
                <h2 style={{color:accent_color, textShadow:`2px 2px 4px ${primary_color}`, margin:"0"}}>היי, אנחנו מתנצלים אך האתר נסגר באופן זמני לרגל שיפוצים 🛠️</h2>
                <img style={{width:"200px", height:"200px", borderRadius:"50%"}} src={imgURL} alt={`${domain.split(".")[0]}_logo`}/>
                <h2 style={{color:accent_color, textShadow:`2px 2px 4px ${primary_color}`, margin:"0"}}>נפתח שוב בקרוב!</h2>
            </div>
        </div>
    )
}
